import InputS1Default from "./Inputs/InputS1Default";
import InputS1 from "./Inputs/InputS1";
import InputCurrencyS1 from "./Inputs/InputCurrencyS1";
import InputMaskS1 from "./Inputs/InputMaskS1";
import TextareaS1 from "./Textarea/TextareaS1";
import SelectS1 from "./Select/SelectS1";
import SelectD1 from "./Select/SelectD1";
import AsyncSelectS1 from "./Select/AsyncSelectS1";
import AsyncSelectD1 from "./Select/AsyncSelectD1";
import CheckboxS1 from "./Checkbox/CheckboxS1";
import CheckboxD1 from "./Checkbox/CheckboxD1";
import RadioS1 from "./Radio/RadioS1";
import RadioS2 from "./Radio/RadioS2";
import UploadS1 from "./Upload/UploadS1";
import UploadS2 from "./Upload/UploadS2";
import NewDatePicker from "./NewDatePicker";
import NewDatePickerDefault from "./NewDatePicker/default";
import NewDatePickerTwo from "./NewDatePicker/newDatePicker";
import CreatableSelect from "./CreatableSelect";
import FormattedNumberInputS1 from "./Inputs/FormattedNumberInputS1";
import NewDefaultInput from "./Inputs/NewDefaultInput";
import SearchInput from "./Inputs/SearchInput"
import NewCheckbox from "./Checkbox/NewCheckbox";
import NewInputMask from "./Inputs/NewInputMask";
import NewAsyncSelectS1 from "./Select/NewAsyncSelectS1";
import NewSelectS1 from "./Select/NewSelectS1";
import NewSwitch from "./Checkbox/NewSwitch";
import NewTextareaS1 from "./Textarea/NewTextareaS1";
import PasswordField from "./Inputs/PasswordField";

import "./style.scss";

export default {
    InputS1Default,
    InputS1,
    InputCurrencyS1,
    InputMaskS1,
    NewInputMask,
    TextareaS1,
    SelectS1,
    NewSelectS1,
    SelectD1,
    AsyncSelectS1,
    NewAsyncSelectS1,
    AsyncSelectD1,
    CheckboxS1,
    CheckboxD1,
    NewCheckbox,
    NewSwitch,
    RadioS1,
    RadioS2,
    UploadS1,
    UploadS2,
    NewDatePicker,
    NewDatePickerDefault,
    NewDatePickerTwo,
    CreatableSelect,
    FormattedNumberInputS1,
    NewDefaultInput,
    SearchInput,
    NewTextareaS1,
    PasswordField
};
